import { Component, Input } from '@angular/core';

@Component({
  selector: 'el-base-neo-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
})
export class InfoBoxComponent {
  @Input() message = '';
}
